import { createTheme } from '@mui/material';

export const DarkTheme = createTheme({
    palette: {
        mode: 'dark',
        primary: {
            main: '#5BB2DD',
            contrastText: '#101246'
        },
        secondary: {
            main: '#5BB2DD',
            contrastText: '#101246'
        },
        error: {
            main: '#FF5C5C'
        },
        warning: {
            main: '#FFC1AD',
            contrastText: '#101246'
        },
        background: {
            default: '#0B1020',
            paper: '#171D33'
        },
        text: {
            primary: '#F4F7FB',
            secondary: '#AAB6C8',
            disabled: '#748096'
        },
        divider: '#2A344F'
    },
    typography: {
        fontFamily: '"Open Sans", "Roboto", "Arial", sans-serif',
        h1: { fontFamily: '"DIN 2014 NOW", "Open Sans", "Roboto", sans-serif', fontWeight: 700 },
        h2: { fontFamily: '"DIN 2014 NOW", "Open Sans", "Roboto", sans-serif', fontWeight: 700 },
        h3: { fontFamily: '"DIN 2014 NOW", "Open Sans", "Roboto", sans-serif', fontWeight: 700 },
        h4: { fontFamily: '"DIN 2014 NOW", "Open Sans", "Roboto", sans-serif', fontWeight: 700 },
        h5: { fontFamily: '"DIN 2014 NOW", "Open Sans", "Roboto", sans-serif', fontWeight: 700 },
        h6: { fontFamily: '"DIN 2014 NOW", "Open Sans", "Roboto", sans-serif', fontWeight: 700 },
        button: {
            fontWeight: 700,
            textTransform: 'none'
        }
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: 6
                }
            }
        },
        MuiCard: {
            styleOverrides: {
                root: {
                    color: '#F4F7FB'
                }
            }
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#5BB2DD'
                    }
                }
            }
        },
        MuiInputLabel: {
            styleOverrides: {
                root: {
                    '&.Mui-focused': {
                        color: '#5BB2DD'
                    }
                }
            }
        }
    }
});
